// https://github.com/stefanpenner/es6-promise
require('es6-promise').polyfill();

import axios from 'axios';
window.axios = axios;

import Vue from 'vue';
Vue.prototype.$http = axios;

import SyndicationWidget from './SyndicationWidget.vue';

var widget_id = "wire-syndication-widget-anchor";
document.write(`<div id="${widget_id}"></div>`);

document.addEventListener("DOMContentLoaded", function() {

    window.syndication_widget = new Vue({
        name: 'syndication-app',
        el: `#${widget_id}`,
        render: h => h(SyndicationWidget),
    });

});